import { Action } from '@ngrx/store';
import { ProspectQueryParameters } from '@quorum/models/xs-query';
import { LocalSettingsState } from './local-settings/local-settings.interfaces';

export const LOAD_APPOINTMENT_DETAIL = '[SALESPLANNER] Load Appointment Detail';
export class LoadAppointmentDetail implements Action {
  readonly feature = 'crm';
  readonly type = LOAD_APPOINTMENT_DETAIL;
  readonly triggerStorageSync = false;
  constructor(public payload: { appointmentId: number }) {}
}

export const LOAD_TASK_DETAIL = '[SALESPLANNER] Load Task Detail';
export class LoadTaskDetail implements Action {
  readonly feature = 'crm';
  readonly type = LOAD_TASK_DETAIL;
  readonly triggerStorageSync = false;
  constructor(public payload: { taskId: number }) {}
}

export const LOAD_SERVICE_APPOINTMENT_DETAIL = '[SALESPLANNER] Load Service Appointment Detail';
export class LoadServiceAppointmentDetail implements Action {
  readonly feature = 'crm';
  readonly type = LOAD_SERVICE_APPOINTMENT_DETAIL;
  readonly triggerStorageSync = false;
  constructor(public payload: { appointmentId: number }) {}
}

export const LOAD_DEALER_PROMOTION_DETAIL = '[SALESPLANNER] Load Dealer Promotion Detail';
export class LoadDealerPromotionDetail implements Action {
  readonly feature = 'crm';
  readonly type = LOAD_DEALER_PROMOTION_DETAIL;
  readonly triggerStorageSync = false;
  constructor(public payload: { dealerPromotionId: number; dealerPromotionSequence: number }) {}
}

export const LOAD_DELIVERY_DETAIL = '[SALESPLANNER] Load Delivery Detail';
export class LoadDeliveryDetail implements Action {
  readonly feature = 'crm';
  readonly type = LOAD_DELIVERY_DETAIL;
  readonly triggerStorageSync = false;
  constructor(public payload: { deliveryId: number }) {}
}

export const LOAD_PROSPECT_DETAIL = '[SALESPLANNER] Load Prospect Detail';
export class LoadProspectDetail implements Action {
  readonly feature = 'crm';
  readonly type = LOAD_PROSPECT_DETAIL;
  readonly triggerStorageSync = false;
  constructor(public payload: { prospectId: number }) {}
}

export const UPDATE_FEATURE_LOADING_STATE = '[SALESPLANNER] Update Feature Loading in State';
export class UpdateFeatureLoadingInState implements Action {
  readonly feature = 'crm';
  readonly type = UPDATE_FEATURE_LOADING_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: { loaded: boolean }) {}
}

export const RESET_STATE = '[SALESPLANNER] Reset State';
export class ResetState implements Action {
  readonly feature = 'crm';
  readonly type = RESET_STATE;
  readonly triggerStorageSync = false;
  constructor(public payload: {}) {}
}

// Dispatched by the local-settings apply effect when persisted server-side settings have just
// overlaid current state and the navigation effect already kicked off the initial dataset loads
// (so the visible activities/prospects were filtered with stale values). The handler lives in
// salesplanner-legacy.effects.ts where the cross-lib imports for prospects already exist, so
// libs/.../local-settings/* can stay free of @quorum/xsr-entities/state edges.
export const REFRESH_DATASETS_FOR_APPLIED_SETTINGS = '[SALESPLANNER] Refresh Datasets For Applied Settings';
export class RefreshDatasetsForAppliedSettings implements Action {
  readonly feature = 'crm';
  readonly type = REFRESH_DATASETS_FOR_APPLIED_SETTINGS;
  readonly triggerStorageSync = false;
  constructor(public payload: { localSettings: LocalSettingsState; prospectQueryParameters: ProspectQueryParameters }) {}
}

export type SalesplannerLegacyAction =
  | LoadAppointmentDetail
  | LoadTaskDetail
  | LoadServiceAppointmentDetail
  | LoadProspectDetail
  | UpdateFeatureLoadingInState
  | ResetState
  | RefreshDatasetsForAppliedSettings;
